import React, { useContext, useState } from "react";
import Form from "../../../../../assets/Style/Form.module.css";
import acm from "../AddCarModal.module.css";
import cpf from "./CompanyPriceForm.module.css";
import { AppContext } from "../../../../../providers/appProvider";
import { useAuth } from "../../../../../providers/authProvider";
import { baseFileURL } from "../../../../../Api";
import Attachment from "../../../../../assets/Icon/Attachment";
import { INSPECTION_WEBSITE_ID } from "../../../../../utils/constans";
import { useTranslation } from 'react-i18next';

const CompanyPriceForm = ({ newCar, setNewCar, isAdd, prices }) => {
  const { t } = useTranslation();
  
  const { appState, app } = useContext(AppContext);

  const toIntOrDefault = (value, defaultValue = 0) => {
    const intValue = parseInt(value);
    return isNaN(intValue) ? defaultValue : intValue;
  };

  var companyPrice = prices.companyPrice;
  var percent = prices.companyPercent;

  const handleChange = (event) => {
    let val = convertToInt(event.target.value);
    setNewCar({
      ...newCar,
      [event.target.name]: val,
    });
  };

  const handleCarPriceChange = (event) => {
    let val = convertToInt(event.target.value);

    let updatedInsurance = newCar.insurance;
    let updatedPrice = newCar.car_price_insurance;

    if (val >= 20000) {
      updatedInsurance = 1;
    } 
    
    if (updatedInsurance == 1) {
      updatedPrice = Math.max(Math.ceil(val * 0.0015), 50);
    }

    let newState = {
      ...newCar,
      car_price_car: parseInt(val, 10),
      car_price_insurance:  parseInt(updatedPrice, 10),
    };

    setNewCar(newState);
  };

  function convertToInt(str) {
    const num = parseInt(str, 10);
    return isNaN(num) ? 0 : num;
  }

  const handleFocus = (e) => {
    if (e.target.value === "0") {
      setNewCar({
        ...newCar,
        [e.target.name]: "",
      });
    }
  };

  const handleBlur = (e) => {
    if (e.target.value === "") {
      let val = convertToInt(0);
      setNewCar({
        ...newCar,
        [e.target.name]: val,
      });
    }
  };

  const handleKeyPress = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const regex = /^[0-9]+$/; // Regular expression to match only numeric characters

    if (!regex.test(keyValue)) {
      event.preventDefault();
    }
  };

  var isDisable = !app.hasPermission("COMPANY_PRICE_EDIT");

  if (newCar.website_id === INSPECTION_WEBSITE_ID) {
    isDisable = true;
  }





  const handleKeyPressMinus = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const regex = /^[0-9\-]+$/; 
    if (!regex.test(keyValue)) {
        event.preventDefault();
    }
};

const handleFocusMinus = (e) => {
     let val;  
    if (e.target.value === '0') {
      setNewCar({
            ...newCar,
            [e.target.name]: ''
        });
    } 

    if (e.target.value === '-') {
      setNewCar({
            ...newCar,
            [e.target.name]: '-'
        });
    } 

};

const handleBlurMinus = (e) => { 
    
    if (e.target.value === '') { 
        let val = 0;
        setNewCar({
            ...newCar,
            [e.target.name]: val
        });
    }

    if (e.target.value === '-') {
        let val = '-';
        setNewCar({
            ...newCar,
            [e.target.name]: val
        });
    }
};


const handleChangeMinus = (event) => {

    if (event.target.value === '-') {
          
        let val = '-';
        setNewCar({
            ...newCar,
            [event.target.name]: val
        }); 

    } else {

        let val = convertToInt(event.target.value);
        setNewCar({
            ...newCar,
            [event.target.name]: val
        });


    }

   
 };

  return (
    <fieldset className={acm.formField}>
      <legend>{t('CompanyPrice')}</legend>
        <>
          <div className={cpf.groupPrice}>
            <label className={cpf.leftLabel}>{t('CarPrice')}</label>
            <div className={cpf.rightInput}>
              <div className={Form.priceInput}>
                <div className={Form.priceCurrency}>USD</div>
                <input
                  type="text"
                  disabled={isDisable}
                  onKeyPress={handleKeyPress}
                  className={Form.input}
                  name="car_price_car"
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  onChange={handleCarPriceChange}
                  value={newCar.car_price_car}
                />
                <div className={Form.hundred}>.00</div>
              </div>
            </div>
          </div>

          <div className={cpf.groupPrice}>
            <label className={cpf.leftLabel}>{t('ContainerPrice')}</label>
            <div className={cpf.rightInput}>
              <div className={Form.priceInput}>
                <div className={Form.priceCurrency}>USD</div>

                <input
                  type="text"
                  disabled={isDisable}
                  onKeyPress={handleKeyPress}
                  name="car_price_transport"
                  className={Form.input}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  value={newCar.car_price_transport}
                />

                <div className={Form.hundred}>.00</div>
              </div>
            </div>
          </div>

          <div className={cpf.groupPrice}>
            <label className={cpf.leftLabel}>{t('InternalTransportation')}</label>
            <div className={cpf.rightInput}>
              <div className={Form.priceInput}>
                <div className={Form.priceCurrency}>USD</div>

                <input
                  type="text"
                  disabled={isDisable}
                  onKeyPress={handleKeyPress}
                  name="car_price_internal"
                  className={Form.input}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  value={newCar.car_price_internal}
                />

                <div className={Form.hundred}>.00</div>
              </div>
            </div>
          </div>

          <div className={cpf.groupPrice}>
            <label className={cpf.leftLabel}>{t('Procent')}</label>
            <div className={cpf.rightInput}>
              <div className={Form.priceInput}>
                <div className={Form.priceCurrency}>USD</div>
                <input
                  type="text"
                  disabled={isDisable} 
                  className={Form.input}
                  value={percent}
                  min="0"
                  readOnly
                />
                <div className={Form.hundred}>.00</div>
              </div>
            </div>
          </div>

          {newCar.dealer_id > 0 && (
            <>
            <div className={cpf.groupPrice}>
              <label className={cpf.leftLabel}>{t('DealerCommissionCar')}</label>
              <div className={cpf.rightInput}>
                <div className={Form.priceInput}>
                  <div className={Form.priceCurrency}>USD</div>
                  <input
                    type="text"
                    disabled={isDisable}
                    onKeyPress={handleKeyPress}
                    name="car_price_dealer"
                    className={Form.input}
                    onChange={handleChange}
                    value={newCar.car_price_dealer}
                    min="0"
                  />
                  <div className={Form.hundred}>.00</div>
                </div>
              </div>
            </div>
            <div className={cpf.groupPrice}>
              <label className={cpf.leftLabel}>{t('DealerCommissionTransport')}</label>
              <div className={cpf.rightInput}>
                <div className={Form.priceInput}>
                  <div className={Form.priceCurrency}>USD</div>
                  <input
                    type="text"
                    disabled={isDisable}
                    onKeyPress={handleKeyPress}
                    name="car_price_dealer_transport"
                    className={Form.input}
                    onChange={(event) => {
                      let val = convertToInt(event.target.value);
                      setNewCar({
                        ...newCar,  
                        car_price_dealer_transport: val,
                      });
                    }}
                    value={newCar.car_price_dealer_transport}
                    min="0"
                  />
                  <div className={Form.hundred}>.00</div>
                </div>
              </div>
            </div>
            </>
          )}

          <div className={cpf.groupPrice}>
            <label className={cpf.leftLabel}>{t('DocumentPrice')}</label>
            <div className={cpf.rightInput}>
              <div className={Form.priceInput}>
                <div className={Form.priceCurrency}>USD</div>
                <input
                  type="text"
                  disabled={isDisable}
                  onKeyPress={handleKeyPress}
                  name="car_price_document"
                  className={Form.input}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  value={newCar.car_price_document}
                  min="0"
                />
                <div className={Form.hundred}>.00</div>
              </div>
            </div>
          </div>

          <div className={cpf.groupPrice}>
            <label className={cpf.leftLabel}>{t('Insurance')}</label>
            <div className={cpf.rightInput}>
              <div className={Form.priceInput}>
                <div className={Form.priceCurrency}>USD</div>
                <input
                  type="text"
                  disabled={isDisable}
                  onKeyPress={handleKeyPress}
                  name="car_price_insurance"
                  className={Form.input}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  value={newCar.car_price_insurance}
                  min="0"
                />
                <div className={Form.hundred}>.00</div>
              </div>
            </div>
          </div>

          <div className={cpf.groupPrice}>
            <label className={cpf.leftLabel}>{t('Penalty')}</label>
            <div className={cpf.rightInput}>
              <div className={Form.priceInput}>
                <div className={Form.priceCurrency}>USD</div>
                <input
                  type="text"
                  disabled={isDisable}
                  onKeyPress={handleKeyPress}
                  name="car_price_penalty"
                  className={Form.input}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  value={newCar.car_price_penalty}
                  min="0"
                />
                <div className={Form.hundred}>.00</div>
              </div>
            </div>
          </div>

          <div className={cpf.groupPrice}>
            <label className={cpf.leftLabel}>{t('TransferFee')}</label>
            <div className={cpf.rightInput}>
              <div className={Form.priceInput}>
                <div className={Form.priceCurrency}>USD</div>
                <input
                  type="text"
                  disabled={isDisable}
                  onKeyPress={handleKeyPress}
                  name="car_price_transfer_fee"
                  className={Form.input}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  // value={newCar.car_price_transfer_fee}
                  value={
                      baseFileURL === 'https://finance.automoby.ge'
                        ? (newCar.car_price_transfer_fee === 10 ? 30 : newCar.car_price_transfer_fee)
                        : newCar.car_price_transfer_fee
                    }
                  min="0"
                />
                <div className={Form.hundred}>.00</div>
              </div>
            </div>
          </div>

          <div className={cpf.groupPrice}>
            <label className={cpf.leftLabel}>{t('Inspection')}</label>
            <div className={cpf.rightInput}>
              <div className={Form.priceInput}>
                <div className={Form.priceCurrency}>USD</div>
                <input
                  type="text"
                  disabled={!app.hasPermission("COMPANY_PRICE_EDIT")}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  onKeyPress={handleKeyPress}
                  name="car_price_inspection"
                  className={Form.input}
                  onChange={handleChange}
                  value={newCar.car_price_inspection}
                  min="0"
                />
                <div className={Form.hundred}>.00</div>
              </div>
            </div>
          </div>

          <div className={cpf.groupPrice}>
            <label className={cpf.leftLabel}>{t('Other')}</label>
            <div className={cpf.rightInput}>
              <div className={Form.priceInput}>
                <div className={Form.priceCurrency}>USD</div>
                <input
                  type="text"
                  disabled={isDisable}
                  onKeyPress={handleKeyPress}
                  name="car_price_another"
                  className={Form.input}
                  onChange={handleChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  value={newCar.car_price_another}
                  min="0"
                />
                <div className={Form.hundred}>.00</div>
              </div>
            </div>
          </div>

          <div className={cpf.groupPrice}>
            <label className={cpf.leftLabel}>{t('RequestedAmount')}</label>
            <div className={cpf.rightInput}>
              <div className={Form.priceInput}>
                <div className={Form.priceCurrency}>USD</div>
                <input
                  type="text"
                  disabled={isDisable}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  onKeyPress={handleKeyPress}
                  name="car_price_fund"
                  className={Form.input}
                  onChange={handleChange}
                  value={newCar.car_price_fund}
                  min="0"
                  readOnly={
                    !app.hasPermission("FUND_PRICE_EDIT") || newCar.fund_accept
                  }
                />
                <div className={Form.hundred}>.00</div>
              </div>
            </div>
          </div>

          <div className={cpf.groupPrice}>
            <label className={cpf.leftLabel}>{t('RequestProcent')}</label>
            <div className={cpf.rightInput}>
              <div className={Form.priceInput}>
                <div className={Form.priceCurrency}>%</div>
                <input
                  type="text"
                  disabled={
                    !app.hasPermission("FUND_PERCENT_EDIT") ||
                    newCar.fund_accept || isDisable
                  }
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  onKeyPress={handleKeyPress}
                  name="car_percent_fund"
                  className={Form.input}
                  onChange={handleChange}
                  value={newCar.car_percent_fund}
                  min="10"
                  max="100"
                  readOnly={!app.hasPermission("FUND_PERCENT_EDIT") || isDisable}
                />
                <div className={Form.hundred}>.00</div>
              </div>
            </div>
          </div>

 
        <div className={cpf.groupPrice}>
          <label className={cpf.leftLabel}>{t('Discount')}</label>
          <div className={cpf.rightInput}>
            <div className={Form.priceInput}>
              <div className={Form.priceCurrency}>USD</div>
              <input
                type="text"
                disabled={!app.hasPermission("PRICE_DISCOUNT_EDIT") || isDisable}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyPress={handleKeyPress}
                name="car_price_discount"
                className={Form.input}
                onChange={handleChange}
                max="100"
                value={newCar.car_price_discount}
                min="0"
              />
              <div className={Form.hundred}>.00</div>
            </div>
          </div>
        </div>
 

        { app.hasPermission("COMPANY_PRICE_CORRECT_EDIT") &&  

          <div className={cpf.groupPrice}>
            <label className={cpf.leftLabel}>{t('Correct')}</label>
            <div className={cpf.rightInput}>
              <div className={Form.priceInput}>
                <div className={Form.priceCurrency}>USD</div>
             
                <input type="text" 
                      disabled={!app.hasPermission("COMPANY_PRICE_CORRECT_EDIT")} 
                      onFocus={handleFocusMinus} 
                      onBlur={handleBlurMinus} 
                      onKeyPress={handleKeyPressMinus} 
                      name="correct_price" 
                      className={Form.input} 
                      value={newCar.correct_price} 
                      onChange={handleChangeMinus} 
                      min="0" 
                  />

                <div className={Form.hundred}>.00</div>
              </div>
            </div>
          </div>


          }

  


        </> 

 

      <div className={cpf.TotalPrice}>
        <div className={cpf.priceCredit}>
          <span className={cpf.curr}>USD</span>
          {companyPrice}
        </div>
      </div>

      {newCar.company_invoice_doc && newCar.company_invoice_doc.length > 0 && (
        <a
          style={{
            color: "var(--primary-color)",
            display: "flex",
            alignItems: "center",
            gap: 5,
            fontStyle: "italic",
            textDecoration: "underline",
            justifyContent: "flex-end",
            marginTop: "5px",
            marginBottom: "5px",
          }}
          href={baseFileURL + newCar.company_invoice_doc}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Attachment /> ინვოისის გადმოწერა
        </a>
      )}
    </fieldset>
  );
};

export default CompanyPriceForm;
